import { Routes } from '@angular/router';
import { AuthGuard } from '@app/core/auth/auth-guard/auth-guard';
import { DashboardLayoutComponent } from '@app/layout/dashboard-layout/dashboard-layout.component';

export const routes: Routes = [
  {
    path: '',
    component: DashboardLayoutComponent,
    canActivate: [AuthGuard],
    children: [
      {
        path: 'dashboard',
        loadChildren: () => import('./dashboard/dashboard-routing').then(m => m.DASHBOARD_ROUTES),
      },
      {
        path: 'impressum',
        loadComponent: () => import('./impressum/impressum.component').then(m => m.ImpressumComponent),
      },
      {
        path: 'datenschutzerklaerung',
        loadComponent: () =>
          import('./datenschutzerklaerung/datenschutzerklaerung.component').then(m => m.DatenschutzerklaerungComponent),
      },
      { path: 'welcome', redirectTo: 'dashboard/measurement-location-overview', pathMatch: 'full' },
      { path: '', redirectTo: 'dashboard/measurement-location-overview', pathMatch: 'full' },
    ],
  },
  { path: '**', redirectTo: '' },
];
